import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_CONFIGS_LIST_ID");

const expand =
  "expand=fields(select=id,Title,Value)";

export class ConfigService {
  static async getList() {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        return res.data?.value?.map((item: any) => (ConfigService.mapData(item)));
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static mapData(item: any) { 
    return {
      Id: item.id,
      Title: item.fields.Title,
      Value: item.fields.Value
    }
  }
}
